import React from 'react';
import { Button, ListGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PencilOutlineIcon from 'mdi-react/PencilOutlineIcon';
import CloseIcon from 'mdi-react/CloseIcon';
import SyncIcon from 'mdi-react/SyncIcon';
import classNames from 'classnames';

type Props = {
  name: string;
  id: number;
  isDeleted: boolean;
  onEditBranch: () => void;
  handleSyncFaceId: () => void;
};

const ListComponent: React.FC<Props> = ({ name, id, isDeleted, onEditBranch, handleSyncFaceId, ...props }) => {
  const handleDoubleClick = (e: any) => {
    switch (e.detail) {
      case 1:
        break;
      case 2:
        onEditBranch();
        break;
      default:
        break;
    }
  };

  const handleSync = () => {
    handleSyncFaceId();
  };

  const tooltip = isDeleted ? 'Філія видалена' : 'Редагування налаштувань філії';
  const tooltip2 = isDeleted ? 'Філія видалена' : 'Синхронізувати Face Id';

  return (
    <ListGroup.Item id={`${id}`} className="list-item cursor-def" onClick={handleDoubleClick} {...props}>
      <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">{tooltip2}</Tooltip>}>
        <Button onClick={handleSync} className={classNames(isDeleted ? 'isDeleted' : '', 'mr-2 p-1 rounded-circle')}>
          <SyncIcon size={18} />
        </Button>
      </OverlayTrigger>
      <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">{tooltip}</Tooltip>}>
        <Button className={classNames(isDeleted ? 'isDeleted' : '', 'mr-2 p-1 rounded-circle')}>
          {isDeleted ? (
            <CloseIcon size={18} onClick={onEditBranch} />
          ) : (
            <PencilOutlineIcon size={18} onClick={onEditBranch} />
          )}
        </Button>
      </OverlayTrigger>{' '}
      {name} {isDeleted && <span className="text-danger">(видалена)</span>}
    </ListGroup.Item>
  );
};

export default ListComponent;
